"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.boostTiers = exports.boostProductTierYearlyConfig = exports.boostProductTierMonthlyConfig = exports.boostProductTierConfig = exports.BOOST_TERMS_AND_CONDITIONS_URL = exports.BOOST_SUBSCRIPTION_FEATURE_PERKS = exports.BOOST_SUBSCRIPTION_FEATURES = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var boostTiers = exports.boostTiers = {
  BASIC: "BASIC",
  PLUS: "PLUS",
  PREMIUM: "PREMIUM",
  VIP: "VIP"
};
var BOOST_SUBSCRIPTION_FEATURES = exports.BOOST_SUBSCRIPTION_FEATURES = {
  CREDIT_LINE: "CREDIT_LINE",
  BILL_TRACKING: "BILL_TRACKING",
  CREDIT_MONITORING: "CREDIT_MONITORING",
  ALL_BUREAU_SUPPORT: "ALL_BUREAU_SUPPORT",
  NO_HARD_PULL: "NO_HARD_PULL",
  CREDIT_REPORT: "CREDIT_REPORT",
  REPORT_DISPUTE: "REPORT_DISPUTE",
  AI_FINANCIAL_ASSISTANT: 'AI_FINANCIAL_ASSISTANT',
  PRIORITY_SUPPORT: 'PRIORITY_SUPPORT'
};
var BOOST_SUBSCRIPTION_FEATURE_PERKS = exports.BOOST_SUBSCRIPTION_FEATURE_PERKS = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, BOOST_SUBSCRIPTION_FEATURES.CREDIT_LINE, "Credit line"), BOOST_SUBSCRIPTION_FEATURES.BILL_TRACKING, "Bill tracking"), BOOST_SUBSCRIPTION_FEATURES.CREDIT_MONITORING, "Credit monitoring"), BOOST_SUBSCRIPTION_FEATURES.ALL_BUREAU_SUPPORT, "All major bureau support"), BOOST_SUBSCRIPTION_FEATURES.NO_HARD_PULL, "No hard credit pulls"), BOOST_SUBSCRIPTION_FEATURES.CREDIT_REPORT, 'In-depth credit report ($50 value)'), BOOST_SUBSCRIPTION_FEATURES.REPORT_DISPUTE, 'Dispute negative remarks'), BOOST_SUBSCRIPTION_FEATURES.AI_FINANCIAL_ASSISTANT, 'AI financial assistant'), BOOST_SUBSCRIPTION_FEATURES.PRIORITY_SUPPORT, 'Priority support');
var BASIC_PLAN_FEATURES = [{
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_LINE,
  description: [{
    text: "up to ",
    style: {
      fontSize: 24
    }
  }, {
    text: "$1,000",
    style: {
      fontWeight: 700,
      fontSize: 24
    }
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.BILL_TRACKING,
  description: [{
    text: "2 months",
    style: {
      fontWeight: 700,
      fontSize: 24
    }
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_MONITORING,
  description: []
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.ALL_BUREAU_SUPPORT,
  description: []
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.NO_HARD_PULL,
  description: []
}];
var BASIC_PLAN_FEATURES_MOBILE = [{
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_LINE,
  description: [{
    text: "up to "
  }, {
    text: "$1,000",
    style: {
      fontWeight: 700
    }
  }, {
    text: " credit line"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.BILL_TRACKING,
  description: [{
    text: "2 months",
    style: {
      fontWeight: 700
    }
  }, {
    text: "of bill tracking"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_MONITORING,
  description: [{
    text: "Credit monitoring"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.ALL_BUREAU_SUPPORT,
  description: [{
    text: "All major bureau support"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.NO_HARD_PULL,
  description: [{
    text: "No hard credit pulls"
  }]
}];
var PREMIUM_PLAN_FEATURES = [{
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_LINE,
  description: [{
    text: "up to ",
    style: {
      fontSize: 24
    }
  }, {
    text: "$20,000",
    style: {
      fontWeight: 700,
      fontSize: 24
    }
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.BILL_TRACKING,
  description: [{
    text: "12 months",
    style: {
      fontWeight: 700,
      fontSize: 24
    }
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_MONITORING,
  description: []
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.ALL_BUREAU_SUPPORT,
  description: []
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.NO_HARD_PULL,
  description: []
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_REPORT,
  description: []
}];
var PREMIUM_PLAN_FEATURES_MOBILE = [{
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_LINE,
  description: [{
    text: "up to "
  }, {
    text: "$20,000",
    style: {
      fontWeight: 700
    }
  }, {
    text: " credit line"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.BILL_TRACKING,
  description: [{
    text: "12 months",
    style: {
      fontWeight: 700
    }
  }, {
    text: "of bill tracking"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_MONITORING,
  description: [{
    text: "Credit monitoring"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.ALL_BUREAU_SUPPORT,
  description: [{
    text: "All major bureau support"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.NO_HARD_PULL,
  description: [{
    text: "No hard credit pulls"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_REPORT,
  description: [{
    text: "In-depth credit report ($50 value)"
  }]
}];

// TODO check features
var PLUS_PLAN_FEATURES = [{
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_LINE,
  description: [{
    text: "up to ",
    style: {
      fontSize: 24
    }
  }, {
    text: "$5,000",
    style: {
      fontWeight: 700,
      fontSize: 24
    }
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.BILL_TRACKING,
  description: [{
    text: "6 months",
    style: {
      fontWeight: 700,
      fontSize: 24
    }
  }, {
    text: "of bill tracking"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_MONITORING,
  description: []
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.ALL_BUREAU_SUPPORT,
  description: []
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.NO_HARD_PULL,
  description: []
}];
var PLUS_PLAN_FEATURES_MOBILE = [{
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_LINE,
  description: [{
    text: "up to "
  }, {
    text: "$5,000",
    style: {
      fontWeight: 700
    }
  }, {
    text: " credit line"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.BILL_TRACKING,
  description: [{
    text: "6 months",
    style: {
      fontWeight: 700
    }
  }, {
    text: "of bill tracking"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_MONITORING,
  description: [{
    text: "Credit monitoring"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.ALL_BUREAU_SUPPORT,
  description: [{
    text: "All major bureau support"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.NO_HARD_PULL,
  description: [{
    text: "No hard credit pulls"
  }]
}];
var VIP_PLAN_FEATURES = [{
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_LINE,
  description: [{
    text: "up to ",
    style: {
      fontSize: 24
    }
  }, {
    text: "$30,000",
    style: {
      fontWeight: 700,
      fontSize: 24
    }
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.BILL_TRACKING,
  description: [{
    text: "24 months",
    style: {
      fontWeight: 700,
      fontSize: 24
    }
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_MONITORING,
  description: []
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.ALL_BUREAU_SUPPORT,
  description: []
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.NO_HARD_PULL,
  description: []
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_REPORT,
  description: []
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.REPORT_DISPUTE,
  description: []
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.AI_FINANCIAL_ASSISTANT,
  description: []
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.PRIORITY_SUPPORT,
  description: []
}];
var VIP_PLAN_FEATURES_MOBILE = [{
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_LINE,
  description: [{
    text: "up to "
  }, {
    text: "$30,000",
    style: {
      fontWeight: 700
    }
  }, {
    text: " credit line"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.BILL_TRACKING,
  description: [{
    text: "24 months",
    style: {
      fontWeight: 700
    }
  }, {
    text: "of bill tracking"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_MONITORING,
  description: [{
    text: "Credit monitoring"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.ALL_BUREAU_SUPPORT,
  description: [{
    text: "All major bureau support"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.NO_HARD_PULL,
  description: [{
    text: "No hard credit pulls"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.CREDIT_REPORT,
  description: [{
    text: "In-depth credit report ($50 value)"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.REPORT_DISPUTE,
  description: [{
    text: "Dispute negative remarks"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.AI_FINANCIAL_ASSISTANT,
  description: [{
    text: "AI financial assistant"
  }]
}, {
  title: BOOST_SUBSCRIPTION_FEATURES.PRIORITY_SUPPORT,
  description: [{
    text: "Priority support"
  }]
}];
var boostProductTierMonthlyConfig = exports.boostProductTierMonthlyConfig = {
  BASIC: {
    title: "🛰️ Basic Journey",
    name: "Basic",
    icon: "🛰️",
    price: Date.now() >= new Date("2024-02-22T08:00:00.000Z").getTime() ? 14.99 : 9.99,
    originalPrice: 19.99,
    billingPeriod: "Per month",
    maxLine: 1000,
    minLine: 500,
    lookbackPeriod: "2 months",
    perks: ["2 months of instant credit history reported.", "2 months of past bills added to your account.", "Up to $1000/per month reported as credit.*"],
    features: BASIC_PLAN_FEATURES,
    featuresMobile: BASIC_PLAN_FEATURES_MOBILE
  },
  PLUS: {
    title: "🌙 Plus Journey",
    name: "Plus",
    icon: "🌙",
    price: 29.99,
    originalPrice: 69.99,
    billingPeriod: "Per month",
    maxLine: 5000,
    minLine: 1000,
    lookbackPeriod: "6 months",
    perks: ["6 months of instant credit history reported.", "6 months of past bills added to your account.", "Up to $5000/per month reported as credit.*"],
    features: PLUS_PLAN_FEATURES,
    featuresMobile: PLUS_PLAN_FEATURES_MOBILE
  },
  PREMIUM: {
    title: "🪐 Premium Journey",
    name: "Premium",
    icon: "🪐",
    price: Date.now() >= new Date("2024-02-22T08:00:00.000Z").getTime() ? 69.99 : 49.99,
    originalPrice: 99.99,
    billingPeriod: "Per month",
    maxLine: 20000,
    minLine: 5000,
    lookbackPeriod: "12 months",
    label: "Popular",
    perks: ["12 months of instant credit history reported.", "12 months of past bills added to your account.", "Up to $20,000/per month reported as credit.*"],
    features: PREMIUM_PLAN_FEATURES,
    featuresMobile: PREMIUM_PLAN_FEATURES_MOBILE
  },
  VIP: {
    title: "☀️ VIP Journey",
    name: "VIP",
    buttonText: "VIP 🚀",
    icon: "☀️",
    price: Date.now() >= new Date("2024-02-22T08:00:00.000Z").getTime() ? 129.99 : 99.99,
    originalPrice: 274.99,
    billingPeriod: "Per month",
    maxLine: 30000,
    minLine: 10000,
    lookbackPeriod: "24 months",
    label: "Best Value",
    perks: ["24 months of instant credit history reported.", "24 months of past bills added to your account.", "Up to $30,000/per month reported as credit.*"],
    features: VIP_PLAN_FEATURES,
    featuresMobile: VIP_PLAN_FEATURES_MOBILE
  }
};
var boostProductTierYearlyConfig = exports.boostProductTierYearlyConfig = {
  BASIC: {
    title: "🛰️ Basic Journey",
    name: "Basic",
    icon: "🛰️",
    price: 99.99,
    originalPrice: 19.99 * 12,
    billingPeriod: "Per year",
    maxLine: 1000,
    minLine: 500,
    lookbackPeriod: "2 months",
    perks: ["2 months of instant credit history reported.", "2 months of past bills added to your account.", "Up to $1000/per month reported as credit.*"],
    features: BASIC_PLAN_FEATURES,
    featuresMobile: BASIC_PLAN_FEATURES_MOBILE
  },
  PLUS: {
    title: "🌙 Plus Journey",
    name: "Plus",
    icon: "🌙",
    price: 249.99,
    originalPrice: 69.99 * 12,
    billingPeriod: "Per year",
    maxLine: 5000,
    minLine: 1000,
    lookbackPeriod: "6 months",
    perks: ["6 months of instant credit history reported.", "6 months of past bills added to your account.", "Up to $5000/per month reported as credit.*"],
    features: PLUS_PLAN_FEATURES,
    featuresMobile: PLUS_PLAN_FEATURES_MOBILE
  },
  PREMIUM: {
    title: "🪐 Premium Journey",
    name: "Premium",
    icon: "🪐",
    price: 399.99,
    originalPrice: 99.99 * 12,
    billingPeriod: "Per year",
    maxLine: 20000,
    minLine: 5000,
    lookbackPeriod: "12 months",
    label: "Popular",
    perks: ["12 months of instant credit history reported.", "12 months of past bills added to your account.", "Up to $20,000/per month reported as credit.*"],
    features: PREMIUM_PLAN_FEATURES,
    featuresMobile: PREMIUM_PLAN_FEATURES_MOBILE
  },
  VIP: {
    title: "☀️ VIP Journey",
    name: "VIP",
    buttonText: "VIP 🚀",
    icon: "☀️",
    price: 999.99,
    originalPrice: 274.99 * 12,
    billingPeriod: "Per year",
    maxLine: 30000,
    minLine: 10000,
    lookbackPeriod: "24 months",
    label: "Best Value",
    perks: ["24 months of instant credit history reported.", "24 months of past bills added to your account.", "Up to $30,000/per month reported as credit.*"],
    features: VIP_PLAN_FEATURES,
    featuresMobile: VIP_PLAN_FEATURES_MOBILE
  }
};
var boostProductTierConfig = exports.boostProductTierConfig = {
  monthly: boostProductTierMonthlyConfig,
  yearly: boostProductTierYearlyConfig
};
var BOOST_TERMS_AND_CONDITIONS_URL = exports.BOOST_TERMS_AND_CONDITIONS_URL = "https://tomo-public-docs.s3.us-west-1.amazonaws.com/Terms+and+Conditions.pdf";